module.exports = __webpack_public_path__ + "SinniSundi-72732747.webp";